import {
    CREATE_INITIAL_STATE,
    DELETE_SELECTED_TRADE_IN_DEVICE,
    GET_TRADE_IN_DEVICES,
    GET_TRADE_IN_DEVICES_FAILED,
    GET_TRADE_IN_DEVICES_SUCCESS,
    SET_TRADE_IN_DEVICE,
    SET_DEFAULT_STATE,
    SET_SUGGEST_FIELD_VALUE,
    TOGGLE_TRADE_IN_SWITCH,
} from './constants';
import { Device } from './interface';

/**
 * createInitialState
 */
export function createInitialState () {
    return {
        type: CREATE_INITIAL_STATE,
    };
}

/**
 * Set default state
 * @param tradeInSwitch
 */
export function setDefaultState (tradeInSwitch: boolean) {
    return {
        type: SET_DEFAULT_STATE,
        tradeInSwitch,
    };
}

/**
 * Get Devices
 *
 */
export function getTradeInDevices () {
    return {
        type: GET_TRADE_IN_DEVICES,
    };
}

/**
 * Fire when API request success
 * @param payload
 */
export function getTradeInDevicesSuccess (payload: Device[] | null) {
    return {
        type: GET_TRADE_IN_DEVICES_SUCCESS,
        payload,
    };
}

/**
 * Fire when API request fails
 */
export function getTradeInDevicesFailed () {
    return {
        type: GET_TRADE_IN_DEVICES_FAILED,
    };
}

/**
 * set suggest field value
 * @param suggestFieldValue
 */
export function setSuggestFieldValue (suggestFieldValue: string) {
    return {
        type: SET_SUGGEST_FIELD_VALUE,
        suggestFieldValue,
    };
}

/**
 * Toggle trade in switch
 */
export function toggleTradeInSwitch (force?: boolean) {
    return {
        type: TOGGLE_TRADE_IN_SWITCH,
        force,
    };
}

/**
 * select device
 * @params selectedDeviceId
 */
export function setSelectedTradeInDeviceId (selectedDeviceId: string) {
    return {
        type: SET_TRADE_IN_DEVICE,
        selectedDeviceId,
    };
}

/**
 * delete delcted device
 *
 */
export function deleteSelectedDevice () {
    return {
        type: DELETE_SELECTED_TRADE_IN_DEVICE,
    };
}
